package org.example.project.components

import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.launch
import org.example.project.EnableOrgResult
import org.example.project.FirebaseManager
import org.example.project.PrimaryColor

@Composable
fun EnableOrgSection() {
    val scope = rememberCoroutineScope()
    var orgEmail by remember { mutableStateOf("") }
    var isEnablingOrg by remember { mutableStateOf(false) }
    var enableOrgMessage by remember { mutableStateOf<String?>(null) }

    Card(
        colors = CardDefaults.cardColors(containerColor = Color.White),
        elevation = CardDefaults.cardElevation(defaultElevation = 2.dp)
    ) {
        Column(modifier = Modifier.padding(24.dp).fillMaxWidth()) {
            Text(
                text = "Partner Authorization",
                style = MaterialTheme.typography.titleMedium,
                fontWeight = FontWeight.Bold,
                color = Color(0xFF64748B) // Slate 500
            )
            Spacer(modifier = Modifier.height(16.dp))
            OutlinedTextField(
                value = orgEmail,
                onValueChange = { orgEmail = it },
                label = { Text("Account Email") },
                placeholder = { Text("partner@example.com") },
                modifier = Modifier.fillMaxWidth(),
                singleLine = true,
                colors = OutlinedTextFieldDefaults.colors(
                    focusedBorderColor = PrimaryColor,
                    unfocusedBorderColor = Color(0xFFE2E8F0)
                )
            )
            Spacer(modifier = Modifier.height(16.dp))
            Button(
                onClick = {
                    if (orgEmail.isNotBlank()) {
                        scope.launch {
                            isEnablingOrg = true
                            enableOrgMessage = null
                            val result = FirebaseManager.enableOrg(orgEmail)
                            when (result) {
                                is EnableOrgResult.Success -> {
                                    enableOrgMessage = "Successfully authorized: $orgEmail"
                                    orgEmail = ""
                                }
                                is EnableOrgResult.Error -> {
                                    enableOrgMessage = "Error: ${result.message}"
                                }
                            }
                            isEnablingOrg = false
                        }
                    }
                },
                enabled = orgEmail.isNotBlank() && !isEnablingOrg,
                modifier = Modifier.fillMaxWidth(),
                colors = ButtonDefaults.buttonColors(containerColor = PrimaryColor),
                shape = MaterialTheme.shapes.medium
            ) {
                if (isEnablingOrg) {
                    CircularProgressIndicator(
                        modifier = Modifier.size(20.dp),
                        color = Color.White,
                        strokeWidth = 2.dp
                    )
                } else {
                    Text("Authorize", fontWeight = FontWeight.Bold)
                }
            }

            if (enableOrgMessage != null) {
                val isError = enableOrgMessage!!.startsWith("Error")
                Spacer(modifier = Modifier.height(16.dp))
                Surface(
                    color = if (isError) Color(0xFFFEF2F2) else Color(0xFFF0FDF4),
                    shape = MaterialTheme.shapes.small,
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Row(
                        modifier = Modifier.padding(16.dp),
                        verticalAlignment = androidx.compose.ui.Alignment.CenterVertically
                    ) {
                        Text(
                            text = enableOrgMessage!!,
                            color = if (isError) Color(0xFFDC2626) else Color(0xFF16A34A),
                            style = MaterialTheme.typography.bodySmall,
                            fontWeight = FontWeight.Medium
                        )
                    }
                }
            }
        }
    }
}
